import { Borrower, Demographic, PrefillResponse } from '@types';
import { ApiLogger, logAPIEvent } from 'fmc-digital-common';
import { produce } from 'immer';
import { isEmpty } from 'lodash';
import { v4 } from 'uuid';
import { auth, config } from '../../../config';
const demographic: Demographic = {
    ethnicity: {
        hispanicOrLatino: null,
        hispanicOrLatinoList: {
            mexican: null,
            puertoRican: null,
            cuban: null,
            other: null,
            enteredOrigin: ''
        },
        notHispanicOrLatino: null,
        noInformationProvided: null
    },
    race: {
        americanIndianOrAlaskaNative: null,
        americanIndianOrAlaskaNativeName: null,
        asian: null,
        asianList: {
            asianIndian: null,
            chinese: null,
            filipino: null,
            japanese: null,
            korean: null,
            vietnamese: null,
            other: null,
            enteredRace: null
        },
        blackOrAfricanAmerican: null,
        nativeHawaiianOrOtherPacificIslander: null,
        nativeHawaiianOrOtherPacificIslanderList: {
            nativeHawaiian: null,
            guamanianOrChamorro: null,
            samoan: null,
            other: null,
            enteredRace: null
        },
        white: null,
        noInformationProvided: null
    },
    sex: {
        male: null,
        female: null,
        noInformationProvided: null
    }
};
export const sanitizeNBSObj = (obj: any) => {
    if (isEmpty(obj) || ['firstName', 'lastName', 'email', 'phone', 'ssn'].every(key => isEmpty(obj[key]))) {
        return null;
    } else if (!isEmpty(obj)) {
        return {
            ...obj,
            firstName: obj?.firstName || 0,
            lastName: obj?.lastName || 0,
            email: obj?.email || 0,
            phone: obj?.phone || 0,
            ssn: obj?.ssn || 0
        };
    }
    return obj;
};
const select = (data: PrefillResponse) => {
    return produce(data, draft => {
        draft.borrowers = draft.borrowers.map((borrower: Borrower) => ({
            ...borrower,
            hasUserChangedPhone: '',
            hasUserChangedHomePhone: '',
            hasUserChangedEmail: '',
            borrowerOccupyProperty: true,
            keepCurrentBorrower: true,
            borrowerNameCorrect: true,
            demographic
        }));
        draft.subjectProperty.additionalLien = draft?.subjectProperty?.additionalLien ?? false;
        return draft;
    });
};
export const useFullAppPrefill = ({ loanNumber }: { loanNumber: string }) => ({
    queryKey: ['digital-application', loanNumber],
    useErrorBoundary: false,
    queryFn: async () =>
        ApiLogger(
            {
                method: 'get',
                url: `${config.env('prefillUrl')}/prefill/loan/${loanNumber}`,
                headers: {
                    'x-correlation-id': v4().toString(),
                    Authorization: `Bearer ${auth.getOkta().getAccessToken()}`,
                    'x-api-key': config.env('xApiKey'),
                    source: 'DigiApp'
                }
            },
            logAPIEvent
        ),
    select
});
